/**
 * Root-level slugs the SEO-page route must never match.
 *
 * Cross-tier sync obligation (plan §11): this list must stay in sync with
 * `strapi/src/api/seo-page/content-types/seo-page/lifecycles.ts`. Strapi
 * blocks reserved slugs at publish time; the Angular guard blocks them at
 * route match time. Both layers are required — Strapi alone does not protect
 * against a slug whose reservation was added after the page was published,
 * and the Angular guard alone does not protect against the CMS serving a
 * reserved slug back to the bootstrap fetch.
 *
 * When adding a new top-level Angular route, add its first segment here AND
 * to the Strapi-side constant. The backend Jest test
 * (see §11 H7 "cross-tier equality test") fails the build on drift.
 */
export const RESERVED_SLUGS: ReadonlySet<string> = new Set<string>([
  '',
  'home',
  'admin',
  'api-insights',
  'vacatures',
  'vacancies',
  'opdrachtgevers',
  'employers',
  'werkgevers',
  'over-blauwtand',
  'about',
  'over',
  'werken-bij',
  'stories',
  'auteur',
  'contact',
  'privacy-statement',
  'open-sollicitatie',
  'open-application',
  'sitemap.xml',
  'robots.txt',
  'favicon.ico',
  'sitemap',
  'robots',
  'assets',
  'static',
  'images',
]);

export function isReservedSlug(slug: string | null | undefined): boolean {
  if (slug == null) return true;
  return RESERVED_SLUGS.has(slug.trim().toLowerCase());
}
